// extracted by mini-css-extract-plugin
export default {"zapleczeHeaderBar":"ZapleczeHeaderBar_zapleczeHeaderBar__kxBu1"};